import axios from 'axios'
const API_URL = 'https://wift-payments.herokuapp.com'

export function subscriptionIntent (jwt) {
    return axios.post(`${API_URL}/subscription_intents`, {}, { headers: { Authorization: `Bearer: ${jwt}`}})
  }